import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import NavigationItemDesktop from './NavigationItemDesktop';
import { useSelector } from 'react-redux';
import { MegaMenuVisibility } from '../constants';

const NavigationDesktop = () => {
  const allLinks = useSelector((state) => state.navigation.contentLinks);
  const contentLinks = useMemo(
    () =>
      (allLinks || []).filter(
        (link) => link.visibility !== MegaMenuVisibility.MobileOnly
      ),
    [allLinks]
  );
  const [activeMegaMenu, setActiveMegaMenu] = useState();
  const [headerStopOverlay, setHeaderStopOverlay] = useState(false);
  const [headerHasOpenedMenu, setHeaderHasOpenedMenu] = useState(false);
  const megaMenuActiveMenuTimer = useRef(null);
  const megaMenuHasOpenedMenuTimer = useRef(null);

  const clearMegaMenuActiveMenuTimer = () => {
    if (megaMenuActiveMenuTimer.current) {
      clearTimeout(megaMenuActiveMenuTimer.current);
      megaMenuActiveMenuTimer.current = null;
    }
  };

  const clearMegaMenuHasOpenedMenuTimer = () => {
    if (megaMenuHasOpenedMenuTimer.current) {
      clearTimeout(megaMenuHasOpenedMenuTimer.current);
      megaMenuHasOpenedMenuTimer.current = null;
    }
  };

  const onLinkHover = useCallback((link, isMegaMenu) => {
    clearMegaMenuActiveMenuTimer();
    megaMenuActiveMenuTimer.current = setTimeout(() => {
      setActiveMegaMenu(link);
      megaMenuActiveMenuTimer.current = null;
      if (isMegaMenu) {
        setHeaderStopOverlay(true);
        megaMenuHasOpenedMenuTimer.current = setTimeout(() => {
          setHeaderHasOpenedMenu(true);
          clearMegaMenuHasOpenedMenuTimer();
          megaMenuHasOpenedMenuTimer.current = null;
        }, 200);
      } else {
        setHeaderHasOpenedMenu(false);
      }
    }, 100);
  }, []);

  const onMouseLeaveLink = useCallback(() => {
    clearMegaMenuActiveMenuTimer();
    megaMenuActiveMenuTimer.current = setTimeout(() => {
      setActiveMegaMenu(null);
      megaMenuActiveMenuTimer.current = null;
      setHeaderStopOverlay(false);
      setHeaderHasOpenedMenu(false);
    }, 100);
  }, []);

  useEffect(() => {
    const header = document.getElementById('header');
    if (!header) {
      return;
    }

    const handleMouseLeave = () => {
      onMouseLeaveLink();
    };

    header.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      header.removeEventListener('mouseleave', handleMouseLeave);
      clearMegaMenuActiveMenuTimer();
    };
  }, [onMouseLeaveLink]);

  useEffect(() => {
    const header = document.getElementById('header');
    if (!header) {
      return;
    }

    header.classList.toggle('header--stop-overlay', headerStopOverlay);
    header.classList.toggle('header--has-opened-menu', headerHasOpenedMenu);
  }, [headerStopOverlay, headerHasOpenedMenu]);

  return (
    <NavigationItemDesktop
      links={contentLinks}
      {...{ onLinkHover, activeMegaMenu }}
    />
  );
};

export default NavigationDesktop;
